var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.962,
    height: 26,
    viewBox: "0 0 28.962 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".calendar-a{fill:none;stroke:#636166;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1374.951 -436.039)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "calendar-a",
    y1: 6.495,
    transform: "translate(1383.104 437.039)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "calendar-a",
    y1: 6.495,
    transform: "translate(1395.762 437.039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "calendar-a",
    d: "M25.746,3.105A1.834,1.834,0,0,1,27.461,5.04V21.992a2.017,2.017,0,0,1-1.8,2.186H2.3A2.018,2.018,0,0,1,.5,21.992V5.04A1.835,1.835,0,0,1,2.216,3.105Z",
    transform: "translate(1375.452 436.861)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "calendar-a",
    x2: 26.109,
    transform: "translate(1376.379 447.879)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.450f51f3.svg";
export { ForwardRef as ReactComponent };